export const acikRenkler = {
  murekkep: '#17191b',
  sari: '#ffd12f',
  sariSoluk: '#fff7d9',
  zemin: '#f7f7f7',
  cizgi: '#e5e5e5',
  gri: '#6b6b6b',
  acik: '#fafafa',
  beyaz: '#ffffff',
  vurguYazi: '#17191b',
  tersYazi: '#ffffff',
  sabitBeyaz: '#ffffff',
  sabitKoyu: '#17191b',
  hata: '#a63327',
  hataCizgi: '#b64432',
  odak: '#937400',
  golge: '#00000024',
};
export type Renkler = typeof acikRenkler;
export const koyuRenkler: Renkler = {
  murekkep: '#f2f3f5',
  sari: '#ffd12f',
  sariSoluk: '#3b331c',
  zemin: '#131518',
  cizgi: '#393d44',
  gri: '#b1b5bd',
  acik: '#24272c',
  beyaz: '#1b1e22',
  vurguYazi: '#131518',
  tersYazi: '#17191b',
  sabitBeyaz: '#ffffff',
  sabitKoyu: '#17191b',
  hata: '#ffb2a8',
  hataCizgi: '#e98b7d',
  odak: '#ffd12f',
  golge: '#00000066',
};
